import { render, staticRenderFns } from "./px-sidebar-divisor.vue?vue&type=template&id=212720b5&scoped=true&"
import script from "./px-sidebar-divisor.vue?vue&type=script&lang=ts&"
export * from "./px-sidebar-divisor.vue?vue&type=script&lang=ts&"
import style0 from "./px-sidebar-divisor.vue?vue&type=style&index=0&id=212720b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212720b5",
  null
  
)

export default component.exports